import { SET_PAGE_TITLE, CLEAR_PAGE_TITLE } from "../actions/pageTitle";

const initialState = {
  title: null,
};

const pageTitleReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGE_TITLE:
      return {
        ...state,
        title: action.payload,
      };
    case CLEAR_PAGE_TITLE:
      return {
        ...state,
        title: null,
      };
    default:
      return state;
  }
};

export default pageTitleReducer;